(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["karussell-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.tweed-lexikon-carousel');
  const slides = document.querySelectorAll('.tweed-lexikon-slide');
  const progressItems = document.querySelectorAll('.tweed-lexikon-progress-item');
  
  if (!carousel || slides.length === 0) return;
  
  // Initialize first slide as active
  slides[0].classList.add('active');
  if (progressItems.length > 0) progressItems[0].classList.add('active');
  
  // Debounce function for scroll events
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }
  
  // Function to update active slide with center detection
  function updateActiveSlide() {
    const carouselRect = carousel.getBoundingClientRect();
    const carouselCenter = carouselRect.left + carouselRect.width / 2;
    
    let closestSlide = null;
    let closestDistance = Infinity;
    
    slides.forEach((slide, index) => {
      const slideRect = slide.getBoundingClientRect();
      const slideCenter = slideRect.left + slideRect.width / 2;
      const distance = Math.abs(slideCenter - carouselCenter);
      
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSlide = index;
      }
      
      slide.classList.remove('active');
    });
    
    if (closestSlide !== null) {
      slides[closestSlide].classList.add('active');
      
      // Update progress indicators
      progressItems.forEach((item, index) => {
        if (index === closestSlide) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }
  }
  
  // Smooth scroll to center the active slide
  function centerActiveSlide() {
    const activeSlide = document.querySelector('.tweed-lexikon-slide.active');
    if (!activeSlide) return;
    
    const slideLeft = activeSlide.offsetLeft - (carousel.offsetWidth - activeSlide.offsetWidth) / 2;
    
    carousel.scrollTo({
      left: slideLeft,
      behavior: 'smooth'
    });
  }
  
  // Update on scroll with debounce
  carousel.addEventListener('scroll', debounce(function() {
    requestAnimationFrame(updateActiveSlide);
  }, 100));
  
  // Update on resize
  window.addEventListener('resize', debounce(function() {
    requestAnimationFrame(updateActiveSlide);
    requestAnimationFrame(centerActiveSlide);
  }, 150));
  
  // Click on progress items to navigate
  progressItems.forEach((item, index) => {
    item.addEventListener('click', function() {
      const slide = slides[index];
      const slideLeft = slide.offsetLeft - (carousel.offsetWidth - slide.offsetWidth) / 2;
      
      carousel.scrollTo({
        left: slideLeft,
        behavior: 'smooth'
      });
    });
  });
  
  // Initial update
  updateActiveSlide();
  centerActiveSlide();
});

  } catch(e) { console.error(e); }
})();
})();
